// ¿La empresa ya generó alguna imagen? Si sí, el onboarding de marca saltea las primeras piezas
// (ADR-2026-10-31-las-primeras-piezas-solo-si-no-genero): quien llega después de pagar ya probó
// Atlas en la prueba gratis, y volver a pedirle que genere le gastaba 3 créditos del plan.
//
// Cuenta lo que quedó en `imagenes_generadas` (activo). Los productos de ejemplo del cuestionario
// no generan nada, así que no cuentan.

import { supabase } from '../supabase';

/** Si la consulta falla, `false`: ante la duda se muestra el paso, como siempre. */
export async function empresaYaGenero(companyId: string): Promise<boolean> {
  try {
    const { data, error } = await supabase
      .from('imagenes_generadas')
      .select('id')
      .eq('id_company', companyId)
      .eq('active', true)
      .limit(1);
    if (error) return false;
    return (data?.length ?? 0) > 0;
  } catch {
    return false;
  }
}
